// CSS
import "./styles/global.scss";
require('corejs-typeahead/dist/typeahead.jquery.js');